module.exports = __webpack_public_path__ + "static/img/zhongXiaoQiYe_details.21d25429.jpg";